import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";
function Mapper(data, status, response, error, component) {
	let output = [];

	let UserType = Functions["custom"]["getUserType"]();

	let dataPath = "";
	if (
		UserType === "POSTB" ||
		UserType === "POSTR" ||
		UserType === "POSTB_SPLIT"
	) {
		sessionStorage.setItem("getCustomerData", JSON.stringify(data.item));
		dataPath = data.items;
		sessionStorage.setItem("imp", data.item.hasActiveImp);
		sessionStorage.setItem(
			"hasPromoPlayNowUnActive",
			data.item.hasPromoPlayNowUnActive,
		);
		sessionStorage.setItem("hasPromoGigaActive", data.item.hasPromoGigaActive);
		sessionStorage.setItem("hasActiveImp", data.item.hasActiveImp);
		sessionStorage.setItem("activeImpDesc", data.item.activeImpDesc);
		sessionStorage.setItem(
			"hasActivePass",
			JSON.stringify(data.item.hasActivatePass),
		);
	} else {
		if (UserType !== "NEO") {
			sessionStorage.setItem(
				"customerDataDate",
				data.item.contractReloadDateFormated,
			);
		}
		sessionStorage.setItem("getCustomerData", JSON.stringify(data.item));
		dataPath =
			UserType === "NEO" ? "" : data.item.listOfAvailablePrepaidServices;
	}
	if (dataPath) {
		dataPath.map((itm, idx) => {
			let property = {};
			//if item does not have a name -busServiceDes do not add to output
			if (itm.busServiceDes !== null) {
				property["rateplanDescription"] = itm.rateplanDescription;
				property["disabledAndCannotBeActivated"] =
					itm.disabledAndCannotBeActivated;
				property["serviceDes"] = itm.serviceDes;
				if (itm.listOfAvailableTypesOfPurchase) {
					property["eligibleInPortal"] =
						itm?.listOfAvailableTypesOfPurchase[0]?.eligibleInPortal;
					property["visibleInPortal"] =
						itm?.listOfAvailableTypesOfPurchase[0]?.visibleInPortal;
					property["pt"] = itm?.listOfAvailableTypesOfPurchase[0]?.type;
				}
				if (itm.offerList) {
					property["bundle"] = itm?.offerList[0]?.bundle;
					property["offerList"] = itm?.offerList;
				} else {
					property["bundle"] = itm.bundle;
				}
				property["bundleMeasUnit"] = itm.bundleMeasUnit;
				property["tariff"] = itm.tariff;
				property["tariffUnit"] = itm.tariffUnit;
				property["tariffMeasunit"] = itm.tariffMeasunit;
				property["period"] = itm.period;
				property["periodMeasunit"] =
					itm.periodMeasunit || itm.tariffMeasunitTeaserFormated;
				property["tariffMeasunitTeaserFormated"] =
					itm.tariffMeasunitTeaserFormated;
				property["serviceGroup"] = itm.serviceGroup;
				property["jointID"] = itm.jointID;
				property["busServiceDes"] = itm.busServiceDes;
				property["mtbSubtitle"] = itm.mtbSubtitle;
				property["active"] = itm.active;
				property["type"] = itm.type;
				property["teaser"] = itm.teaser;
				property["summerOfferAmount"] = itm.summerOfferAmount;
				property["summerOfferActive"] = itm.summerOfferActive;
				property["bannerTeaser"] = itm.bannerTeaser;
				property["billingDate"] = itm.billingDate;
				property["impAddOn"] = itm.impAddOn;
				property["purchaseOptions"] = itm.purchaseOptions;
				property["canBeActivated"] = itm.canBeActivated;
				property["inValidBillCycle"] = itm.inValidBillCycle;
				property["modal"] = itm;
				property["id"] = itm.bundle;
				output.push(property);
			}
		});
	}
	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;

	return {
		id: {
			alias: "id",
			type: "text",
			label: "ID",
			editable: editable,
		},
		pt: {
			alias: "pt",
			type: "hidden",
		},
		rateplanDescription: {
			alias: "rateplanDescription",
			type: "text",
			label: "",
			editable: editable,
		},
		serviceDes: {
			alias: "serviceDes",
			type: "text",
			label: "",
			editable: editable,
		},
		bundle: {
			alias: "bundle",
			type: "text",
			label: "",
			editable: editable,
		},
		bundleMeasUnit: {
			alias: "bundleMeasUnit",
			type: "text",
			label: "",
			editable: editable,
		},
		tariff: {
			alias: "tariff",
			type: "text",
			label: "",
			editable: editable,
		},
		tariffUnit: {
			alias: "tariffUnit",
			type: "text",
			label: "",
			editable: editable,
		},
		tariffMeasunit: {
			alias: "tariffMeasunit",
			type: "text",
			label: "",
			editable: editable,
		},
		period: {
			alias: "period",
			type: "text",
			label: "",
			editable: editable,
		},
		periodMeasunit: {
			alias: "periodMeasunit",
			type: "text",
			label: "",
			editable: editable,
		},
		serviceGroup: {
			alias: "serviceGroup",
			type: "text",
			label: "",
			editable: editable,
		},
		jointID: {
			alias: "jointID",
			type: "number",
			label: "",
			editable: editable,
		},
		busServiceDes: {
			alias: "busServiceDes",
			type: "text",
			label: "",
			editable: editable,
		},
		active: {
			alias: "active",
			type: "boolean",
			label: "",
			editable: editable,
		},
		eligibleInPortal: {
			alias: "eligibleInPortal",
			type: "boolean",
			label: "",
			editable: editable,
		},
		visibleInPortal: {
			alias: "visibleInPortal",
			type: "boolean",
			label: "",
			editable: editable,
		},
		type: {
			alias: "type",
			type: "text",
			label: "",
			editable: editable,
		},
		teaser: {
			alias: "teaser",
			type: "text",
			label: "",
			editable: editable,
		},
		summerOfferAmount: {
			alias: "summerOfferAmount",
			type: "text",
			label: "",
			editable: editable,
		},
		summerOfferActive: {
			alias: "summerOfferActive",
			type: "boolean",
			label: "",
			editable: editable,
		},
		bannerTeaser: {
			alias: "bannerTeaser",
			type: "boolean",
			label: "",
			editable: editable,
		},
		billingDate: {
			alias: "billingDate",
			type: "text",
			label: "",
			editable: editable,
		},
		impAddOn: {
			alias: "impAddOn",
			type: "text",
			label: "",
			editable: editable,
		},
		purchaseOptions: {
			alias: "purchaseOptions",
			type: "text",
			label: "",
			editable: editable,
		},
		canBeActivated: {
			alias: "canBeActivated",
			type: "boolean",
			label: "",
			editable: editable,
		},
		inValidBillCycle: {
			alias: "inValidBillCycle",
			type: "boolean",
			label: "",
			editable: editable,
		},
		modal: {
			alias: "modal",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				let icon = "";
				let UserType = Functions["custom"]["getUserType"]();
				let summerOfferTemplateUsageFlag = data.summerOfferActive;
				let infoClassName = "";
				if (
					data.type === "IMP" ||
					data.type === "SMS_INTERNET" ||
					data.type === "VOICE_INTERNET"
				) {
					if (summerOfferTemplateUsageFlag) {
						infoClassName = "info summer-offer";
						if (UserType === "PREPAID_FROG") {
							infoClassName += " frog";
						} else if (UserType === "PREPAID_COSMOKARTA") {
							infoClassName = " cosmo";
						} else if (UserType === "PREPAID_WHATSUP") {
							infoClassName = " whatsup";
						}
					} else if (data.bannerTeaser) {
						infoClassName = "info banner-teaser";
						if (UserType === "PREPAID_FROG") {
							infoClassName += " frog";
						} else if (UserType === "PREPAID_COSMOKARTA") {
							infoClassName += " cosmo";
						} else if (UserType === "PREPAID_WHATSUP") {
							infoClassName += " whatsup";
						}
					} else {
						infoClassName = "info";
					}
				} else if (data.type === "COMBO") {
					if (summerOfferTemplateUsageFlag) {
						infoClassName = "info summer-offer";
						if (UserType === "PREPAID_COSMOKARTA") {
							infoClassName += " cosmo";
						}
					} else if (data.bannerTeaser) {
						infoClassName = "info banner-teaser";
						if (UserType === "PREPAID_COSMOKARTA") {
							infoClassName += " cosmo";
						}
					} else {
						infoClassName = "info";
					}
				} else if (data.type === "DAY_PASS") {
					if (data.bannerTeaser) {
						infoClassName = "info banner-teaser";
						if (UserType === "PREPAID_FROG") {
							infoClassName += " frog";
						} else if (UserType === "PREPAID_COSMOKARTA") {
							infoClassName += " cosmo";
						} else if (UserType === "PREPAID_WHATSUP") {
							infoClassName += " whatsup";
						}
					} else {
						infoClassName = "info";
					}
				} else if (
					data.type === "HOURS" ||
					data.type === "WEEKEND" ||
					data.type === "GIGA_WEEK" ||
					data.type === "GIGA_SUMMER" ||
					data.type === "PLAY" ||
					data.type === "SOCIAL" ||
					data.type === "PROMO" ||
					data.type === "CHAT" ||
					data.type === "PLAYINT" ||
					data.type === "SOCHINT" ||
					data.type === "EXTRA" ||
					data.type === "OTE_TV" ||
					data.type === "VOLUME_CHARGE" ||
					data.type === "DAY_PASS"
				) {
					if (summerOfferTemplateUsageFlag) {
						infoClassName = "info summer-offer";
					} else if (data.bannerTeaser) {
						infoClassName = "info banner-teaser";
					} else {
						infoClassName = "info";
					}
				}
				if (data.type === "PROMO")
					icon = (
						<div
							className={
								UserType === "POSTR" ||
								UserType === "POSTB" ||
								UserType === "POSTB_SPLIT"
									? "icon iconpromo"
									: (UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
												JSON.parse(sessionStorage.landPageData)
													.contractInfoCarrier.inListOfWhatuspCss) ||
										  UserType === "PREPAID_WHATSUP"
										? "icon promocosmo promowu"
										: "icon promocosmo cosmo"
							}></div>
					);
				else if (
					(data.type === "EXTRA" || data.type === "GIGA_SUMMER") &&
					UserType !== "PREPAID_FROG"
				) {
					icon = <div className="icon iconsummer"></div>;
				} else if (data.type === "EXTRA" && UserType === "PREPAID_FROG") {
					let numberOfGB = "";
					for (let i = 0; i < data.offerList.length; i++) {
						if (data.offerList[i].bundleMeasUnit === "GB")
							numberOfGB = data.offerList[i].bundle;
					}
					icon = icon = (
						<div className="icon frog">
							{numberOfGB}
							<br />
							GB
						</div>
					);
				} else if (data.type === "GIGA_WEEK")
					icon = (
						<div
							className={
								UserType === "POSTR" ||
								UserType === "POSTB" ||
								UserType === "POSTB_SPLIT" ||
								UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
								UserType === "HYBRID_BUSINESS_COST_CONTROL"
									? "icon iconweek"
									: "icon iconweek cosmo"
							}></div>
					);
				else if (data.type === "HOURS")
					icon = (
						<div
							className={
								UserType === "POSTR" ||
								UserType === "POSTB" ||
								UserType === "POSTB_SPLIT" ||
								UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
								UserType === "HYBRID_BUSINESS_COST_CONTROL"
									? "icon iconhourpass"
									: "icon iconhourpass cosmo"
							}></div>
					);
				else if (data.type === "IMP")
					icon =
						UserType === "PREPAID_FROG" ? (
							<div className="icon frog">
								{data.bundle}
								<br />
								GB
							</div>
						) : (
							<div className="icon icongb">
								<span className="icon-gb-value">{data.bundle}</span>
								<span className="icon-gb-unit">GB</span>
							</div>
						);
				else if (data.type === "COMBO")
					icon = <div className="icon combo"></div>;
				else if (data.type === "VOICE_INTERNET")
					icon = <div className="icon minmb"></div>;
				else if (data.type === "WEEKEND")
					if (UserType === "PREPAID_COSMOKARTA") {
						icon = <div className="icon iconweekend cosmo"></div>;
					} else if (
						UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
						JSON.parse(sessionStorage.getItem("hasPromoGigaActive"))
					) {
						icon = <div className="icon promosklbcc iconweekend"></div>;
					} else {
						icon = <div className="icon iconweekend"></div>;
					}
				else icon = <div className=""></div>;

				return (
					<a
						className={
							data.active && data.type === "IMP"
								? "item active-imp addCursorPointer"
								: data.alreadyPurchasedAndCannotBeActivated || data.active
									? "item active we addCursorPointer"
									: data.disabledAndCannotBeActivated && !data.eligibleInPortal
										? "item disabled we addCursorPointer"
										: data.canBeActivated !== undefined && !data.canBeActivated
											? "item disabled we addCursorPointer"
											: "item"
						}
						onClick={(e) =>
							data.active && data.type === "IMP"
								? clickMe(_this)
								: data.alreadyPurchasedAndCannotBeActivated || data.active
									? null
									: data.disabledAndCannotBeActivated && !data.eligibleInPortal
										? null
										: data.canBeActivated !== undefined && !data.canBeActivated
											? null
											: clickMe(_this)
						}>
						{icon}{" "}
						<span>
							{data.busServiceDes}
							<br />
							<div className={infoClassName}>
								{UserType === "POSTR" ||
								UserType === "POSTB" ||
								UserType === "POSTB_SPLIT"
									? data.teaser
									: data.mtbSubtitle}
							</div>
						</span>
						<div className="price">
							{data.tariff === "0" ? "ΔΩΡΕΑΝ" : data.tariff + "€"}
						</div>
						<div className="clear"></div>
					</a>
				);
			},
		},
		footer: {
			alias: "footer",
			type: "module",
			configuration: {
				module: "footer",
				view: "list",
			},
			editable,
		},
	};
}

function clickMe(_this) {
	let manager = _this.props.manager;
	let data = _this.props.data;

	window["modal"].setState({
		// title: <h4>Confirm deletion</h4>,
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		body: (
			<Manager
				module="modalForPackages"
				inputData={[data]}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

const AvailableContracts = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					url: "{path}",
					method: "POST",
					replace: {
						path: function () {
							let random = new Date().getTime();

							let landPageData = JSON.parse(sessionStorage.landPageData);

							if (
								landPageData.contractInfoCarrier.customerSegment === "POSTB" ||
								landPageData.contractInfoCarrier.customerSegment === "POSTR" ||
								landPageData.contractInfoCarrier.customerSegment ===
									"POSTB_SPLIT"
							) {
								return "/service/getContractAvailableServices?t=".concat(
									random,
								);
							} else {
								return "/service/getCustomerData?t=".concat(random);
							}
						},
					},
					mapper: Mapper,
				},
			},
			template: "availableContractsData",
			templateConfiguration: {
				includeProperties: [],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default AvailableContracts;
